<script setup>
import { useWhiteLabel } from '@/store/useWhitelabel';

const { favicon, appNamePreview, appNameDisplay } = useWhiteLabel();

defineProps({
    icon: {
        type: String,
        default: null
    },

    title: {
        type: String,
        default: null
    }
});
</script>

<template>
    <div class="BrandingImageUpload__image__favicon__tabs">
        <div class="BrandingImageUpload__image__favicon__tabs__tab__wrapper">
            <div class="BrandingImageUpload__image__favicon__tabs__tab --light">
                <img
                    :src="icon ?? favicon"
                    alt=""
                />
                {{ title ?? appNamePreview ?? appNameDisplay }}
            </div>
            <div class="BrandingImageUpload__image__favicon__tabs__tab__legend">
                Browser Tab - Light Mode
            </div>
        </div>

        <div class="BrandingImageUpload__image__favicon__tabs__tab__wrapper">
            <div class="BrandingImageUpload__image__favicon__tabs__tab --dark">
                <img
                    :src="icon ?? favicon"
                    alt=""
                />
                {{ title ?? appNamePreview ?? appNameDisplay }}
            </div>
            <div class="BrandingImageUpload__image__favicon__tabs__tab__legend">
                Browser Tab - Dark Mode
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.BrandingImageUpload__image__favicon__tabs__tab__wrapper {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
}

.BrandingImageUpload__image__favicon__tabs {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.BrandingImageUpload__image__favicon__tabs__tab__legend {
    padding-left: 5px;
    padding-top: 2px;
}

.BrandingImageUpload__image__favicon__tabs__tab {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    padding: 12px;
    border-radius: 12px 12px 0 0;

    img {
        width: 20px !important;
        height: 20px !important;
        margin-right: 8px;
    }

    &.--light {
        background-color: #e8eaed;
    }

    &.--dark {
        background-color: #121212;
        color: white;
    }
}
</style>